import { FileText } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const articles = defineDashboardModule({
  id: "articles",
  nav: [
    { group: "Publishing", title: "Articles", to: "/content", icon: FileText },
  ],
  routes: [
    {
      path: "/content",
      component: lazyPage(() => import("@/routes/content"), "ContentPage"),
    },
    {
      path: "/content/:id",
      component: lazyPage(
        () => import("./routes/article-editor"),
        "ArticleEditorPage"
      ),
    },
  ],
})
